import 'whatwg-fetch'
import { Environment, Network, RecordSource, Store } from 'relay-runtime'

// the function that performs the actual query
async function fetchQuery(operation, variables, cacheConfig, uploadables) {
    // perform the request with an appropriate backoff
    const response = await fetch(`${process.env.API_URL}/graphql`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Locale: localStorage.getItem('locale')
        },
        body: JSON.stringify({
            query: operation.text,
            variables
        })
    })

    // https://github.com/facebook/relay/issues/1816
    // https://github.com/facebook/relay/issues/1913
    if (response.errors) {
        throw response.errors[0]
    }

    // we're done here
    return await response.json()
}

const source = new RecordSource()
const store = new Store(source)
// Create a network layer from the fetch function
const network = Network.create(fetchQuery)

export default new Environment({
    network,
    store
})



// WEBPACK FOOTER //
// ./src/relayEnv.js